import * as cheerio from "cheerio";

export const sanitizeHrefs = (html: string) => {
    try {
        // Load the webpage content into Cheerio
        const $ = cheerio.load(html);

        // Select all anchor tags and add nofollow property
        $("a").each(function (_, element) {
            $(element).attr("rel", "nofollow");
        });

        return $.html();
    } catch {
        return html;
    }
};
